module.exports = __webpack_public_path__ + "img/mo-zm.b21912eb.png";